import { TagsV2 } from '@frontend/api-tag';
import { useCallIntelTrialBackfillWebsocketSubscription } from '@frontend/call-intel-trial';
import {
  useWebsocketCallQueueEventSubscription,
  useWebsocketCallRecordEventSubscription,
  useWebsocketVoicemailEventSubscription,
  useWebsocketExportCallRecords,
} from '@frontend/calls-v2';
import { useAllMessagingWebsockets } from '@frontend/messaging-websockets';
import { useAppScopeStore } from '@frontend/scope';
import { useWebsocketInsuranceVerificationEventSubscription } from './insurance-verification/use-insurance-verification-event-subscription';
import { useWebsocketCallRecordTagEventSubscription } from './phones/use-call-record-tag-notification-event-subscription';
import { useWebsocketMissedCallEventSubscription } from './phones/use-missed-call-notification-event-subscription';
import { useWebsocketVoicemailMessageEventSubscription } from './phones/use-voicemail-notification-event-subscription';
import { useWebsocketVoicemailTagEventSubscription } from './phones/use-voicemail-tag-notification-event-subscription';
import { useWebsocketAppointmentEventSubscription } from './schedule/use-appointment-event-subscription';
import { useWebsocketBulkAppointmentEventSubscription } from './schedule/use-bulk-appointment-event-subscription';
import { useWebsocketScheduleRequestEventSubscription } from './schedule/use-schedule-request-event-subscription';
import { useWebsocketScheduleWaitlistUpdateEventSubscription } from './schedule/use-schedule-waitlist-update-event-subscription';
import { useWebsocketSchedulesEventSubscription } from './schedule/use-schedules-event-subscription';
import { useCallIntelUnhappyCallEventSubscription } from './use-call-intel-unhappy-call-event-subscription';
import { useWebsocketDeviceConnectionSubscription } from './use-device-connection-subscription';
import { useWebsocketFollowupEventSubscription } from './use-followup-event-subscription';
import { useWebsocketFormEventSubscription } from './use-form-event-subscription';
import { useWebsocketPaymentsEventSubscription } from './use-payments-event-subscription';
import { useUserPreferencesWebsocketSubscription } from './user-preference/use-user-preference-websocket-subscription';
import { useUserPresenceWebsocketSubscription } from './user-presence/use-user-presence-websocket-subscription';

export const useAllWebsocketEventSubscriptions = () => {
  const { selectedOrgId } = useAppScopeStore();
  /**
   * Note: not all websocket event subscriptions need to be in here, but this is a convenient place to put them if they're top level
   * For example, some events need specific context to be available before they can be subscribed to properly,
   * such as softphones and team chat events
   **/

  useWebsocketFollowupEventSubscription();

  useWebsocketFormEventSubscription();
  useWebsocketDeviceConnectionSubscription();
  useWebsocketCallQueueEventSubscription();
  useWebsocketCallRecordEventSubscription();
  useWebsocketVoicemailEventSubscription();
  useWebsocketCallRecordTagEventSubscription();
  useWebsocketVoicemailTagEventSubscription();
  useWebsocketVoicemailMessageEventSubscription();
  useWebsocketMissedCallEventSubscription();
  useWebsocketAppointmentEventSubscription();
  useWebsocketBulkAppointmentEventSubscription();
  useWebsocketScheduleRequestEventSubscription();
  useWebsocketScheduleWaitlistUpdateEventSubscription();
  useUserPresenceWebsocketSubscription(selectedOrgId);
  useUserPreferencesWebsocketSubscription();
  useWebsocketSchedulesEventSubscription();
  useWebsocketPaymentsEventSubscription();
  TagsV2.useTagsWSSubscriptions();
  useAllMessagingWebsockets();
  useCallIntelUnhappyCallEventSubscription();
  useCallIntelTrialBackfillWebsocketSubscription();
  useWebsocketInsuranceVerificationEventSubscription();
  useWebsocketExportCallRecords();
};
